var app = angular.module("leonardo");

var ScheduleAddDialog = function($scope, ScheduleService, ReportService, AccountUserService, FormErrorsService,
                                 PermissionService, ngDialog) {

  $scope.report = $scope.ngDialogData.report;
  $scope.permissionService = PermissionService;

  $scope.accountUser = AccountUserService.getAccountUser($scope.report ? $scope.report.account : null);

  $scope.isNull = isNull;

  switch ($scope.report.report_type.toString()) {
    case ReportService.TYPE_DYNAMIC_FORM_STATISTIC:
      $scope.formats = [
        { id: '1', name: 'Excel'},
        { id: '2', name: 'Csv'}
      ];
      break;
    case ReportService.TYPE_CONTACT:
      $scope.formats = [
        { id: '1', name: 'Excel'}
      ];
      break;
    default:
      $scope.formats = [
        { id: '0', name: 'Pdf'},
        { id: '1', name: 'Excel'},
        { id: '2', name: 'Csv'}
      ];
      break;
  }

  $scope.initSchedule = function(schedule) {
    $scope.schedule = {
      recipients: [],
      contact_types: [],
      conditions: {}
    };
    if (!isNull(schedule)) {
      $scope.schedule = angular.copy(schedule);
      $scope.schedule.conditions.type_recurrence = !isNull(schedule.type_recurrence) ?
        schedule.type_recurrence.toString() : schedule.type_recurrence;
    }
  };

  $scope.getData = function() {
    var data = {
      quick_report: $scope.report ? $scope.report.id : '',
      type_recurrence: !isNull($scope.schedule.conditions.type_recurrence) ? $scope.schedule.conditions.type_recurrence.toString() : $scope.schedule.conditions.type_recurrence,
      conditions: {},
      recipients: $scope.schedule.recipients,
      contact_types: $scope.schedule.contact_types,
      type_format: $scope.schedule.type_format,
      sync_sftp: $scope.schedule.sync_sftp
    };
    if ($scope.schedule.id) {
      data.id = $scope.schedule.id;
    }
    if (AccountUserService.currentAccountUser) {
      data.account_user = AccountUserService.currentAccountUser.id;
    }
    if (!isNull(data.type_recurrence)) {
      switch(data.type_recurrence.toString()) {
        case ReportService.RECURRENCE_SCHEDULE_DAILY:
          data.conditions.sending_time = $scope.schedule.conditions.sending_time;
          data.conditions.recurrence = $scope.schedule.conditions.recurrence;
          if ($scope.schedule.conditions.recurrence === 'every_x_days') {
            data.conditions.every_x_days = $scope.schedule.conditions.every_x_days;
          }
          break;
        case ReportService.RECURRENCE_SCHEDULE_WEEKLY:
          data.conditions.every_x_weeks = $scope.schedule.conditions.every_x_weeks;
          data.conditions.weekday = $scope.schedule.conditions.weekday;
          data.conditions.sending_time = $scope.schedule.conditions.sending_time;
          break;
        case ReportService.RECURRENCE_SCHEDULE_MONTHLY:
          data.conditions.month_type = $scope.schedule.conditions.month_type;
          data.conditions.sending_time = $scope.schedule.conditions.sending_time;
          if ($scope.schedule.conditions.month_type === 1) {
            data.conditions.weekday_position_in_month = $scope.schedule.conditions.weekday_position_in_month;
            data.conditions.weekday = $scope.schedule.conditions.weekday;
          }
          else {
            data.conditions.day_send = $scope.schedule.conditions.day_send;
          }
          break;
        case ReportService.RECURRENCE_SCHEDULE_YEARLY:
          data.conditions.year_type = $scope.schedule.conditions.year_type;
          data.conditions.sending_time = $scope.schedule.conditions.sending_time;
          if ($scope.schedule.conditions.year_type === 1) {
            data.conditions.weekday_position_in_month = $scope.schedule.conditions.weekday_position_in_month;
            data.conditions.weekday = $scope.schedule.conditions.weekday;
            data.conditions.month_send = $scope.schedule.conditions.month_send;
          }
          else {
            data.conditions.month_send = $scope.schedule.conditions.month_send;
            data.conditions.day_send = $scope.schedule.conditions.day_send;
          }
          break;
      }
    }
    return data;
  };

  $scope.getNumber = function(num) {
    return new Array(num);
  };

  $scope.emailsError = function () {
    if (!$scope.Form.$submitted) {
      return false;
    }
    else if (($scope.schedule.recipients.length === 0) && ($scope.schedule.contact_types.length === 0)) {
      return true;
    }
    else {
      var error = true;
      angular.forEach($scope.schedule.recipients, function (value) {
        error = updateErrorScope(value, error);
      });
      angular.forEach($scope.schedule.contact_types, function (value) {
        error = updateErrorScope(value, error);
      });
      return error;
    }
  };

  function updateErrorScope(value, error) {
    if (value) {
      error = false;
    }
    return error;
  }

  $scope.showSFTP = function () {
    var sftpTypes = [
      ReportService.TYPE_DYNAMIC_FORM_STATISTIC,
      ReportService.TYPE_DYNAMIC_FORM,
      ReportService.TYPE_ACTION_ITEM,
      ReportService.TYPE_PROPERTY_AMENITIES,
      ReportService.TYPE_ACTIVITY,
      ReportService.TYPE_UNIT,
      ReportService.TYPE_WORKFLOW,
      ReportService.TYPE_MISSING_DOCUMENTS,
      ReportService.TYPE_ON_DEMAND_INSTRUCTION,
      ReportService.TYPE_CONTACT,
      ReportService.TYPE_WORK_ORDERS,
      ReportService.TYPE_MIMO,
      ReportService.TYPE_TEMPLATE
    ];

    return sftpTypes.includes($scope.report.report_type.toString()) && PermissionService.permissionAvailableAccount('permission_upload_sftp');
  };

  $scope.deleteSchedule = function (schedule, index) {
    if (schedule.id) {
      ScheduleService.get(schedule.id).then(function(data) {
        ngDialog.openConfirm({
          template: 'views/templates/dialog/delete.html',
          controller: 'DeleteDialog',
          data: {
            object: data,
            type: 'schedule'
          }
        }).then(function () {
          var schedules = angular.copy($scope.report.schedule);
          angular.forEach(schedules, function (value, key) {
            if (schedule.id == value.id) {
              $scope.report.schedule.splice(key, 1);
            }
          });
        }, function () {
          return;
        });
      });
    }
    else {
      $scope.report.schedule.splice(index, 1);
    }
  };

  $scope.addSchedule = function() {
    $scope.initSchedule();
    $scope.add = true;
  };

  $scope.editSchedule = function (schedule, index) {
    $scope.initSchedule(schedule);
    $scope.add = true;
    $scope.edit = index;
  };

  $scope.cancel = function() {
    $scope.schedule = {
      recipients: [],
      contact_types: [],
      conditions: {}
    };
    $scope.add = false;
    $scope.edit = null;
    $scope.Form.$setPristine();
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.emailsError()) {
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    if ($scope.report) {
      if (!$scope.report.schedule) {
        $scope.report.schedule = [];
      }
      if (data.account_user) {
        data.account_user = data.account_user.id ? data.account_user.id : data.account_user;
      }
      if (!isNull($scope.edit)) {
        ScheduleService.one(data.id).patch(data).then(function (result) {
          $scope.report.schedule[$scope.edit] = result;
          $scope.cancel();
        });
      }
      else {
        data.quick_report = $scope.report.id;
        ScheduleService.post(data).then(function (result) {
          $scope.report.schedule.push(result);
          $scope.cancel();
        });
      }
    }
    else {
      $scope.report = {
        schedule: [data],
        filters: {}
      };
      $scope.cancel();
    }
  };

  $scope.initSchedule();

};

app.controller('ScheduleAddDialog', ['$scope', 'ScheduleService', 'ReportService', 'AccountUserService',
  'FormErrorsService', 'PermissionService', 'ngDialog', ScheduleAddDialog]);
